import { SNAILMAIL_WORLD_URL } from "@/lib/brand";

export const Invitation = () => (
  <section className="bg-[#FAF7F2] py-28 overflow-hidden" data-testid="invitation-section">
    <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">
      <div className="relative">
        <div className="lantern-glow absolute -inset-8 rounded-full opacity-70" />
        <div className="absolute -inset-3 airmail-border rounded-2xl opacity-80" />
        <img src={SNAILMAIL_WORLD_URL} alt="A little world of snail mail: a letter, an origami activity, a word search, stickers, artwork, a playlist card and a colouring sheet among grass, lavender and fireflies" className="relative rounded-xl w-full aspect-[3/2] object-cover border-8 border-white shadow-sm" data-testid="invitation-visual" />
      </div>
      <div>
        <p className="font-serif-display text-3xl sm:text-4xl leading-snug text-stone-900 italic" data-testid="invitation-quote">
          What if something lovely showed up in your mailbox once a month? Something that wasn't a bill, a reminder or another thing asking you to do more.
        </p>
        <p className="mt-10 text-base sm:text-lg text-stone-700 leading-relaxed max-w-lg">
          Welcome to The Little Lantern Club — a monthly happy-mail experience designed to bring a little more light into your everyday.
        </p>
      </div>
    </div>
  </section>
);
